import { NotificationsBySubscriptionsResponse } from "@shared/types/common";
import { constants } from "@shared/constants/constants.ts";
import { TourUrlHandlerConfig } from "@shared/types/localTypes/tour.ts";

import json from "../../json/getNotificationsBySubscriptionNumbers.json";

export default async (_?: object, config?: TourUrlHandlerConfig) => {
  const uuid = config?.originalUrl?.match(constants.UUID_REGEX)?.[0];
  if (!uuid) {
    return {};
  }

  const notificationsResponse = JSON.parse(
    JSON.stringify(await json),
  ) as NotificationsBySubscriptionsResponse;

  return notificationsResponse.items[0].notifications.find(
    (item) => item.uuid === uuid,
  );
};
